"use client"

import { ShortAnswerBlockContent, Theme, defaultTheme } from "@/types"
import { useState, useEffect } from "react"
import { BlockImage } from "../BlockImage"
import { RichTextRenderer } from "../RichTextRenderer"

interface ShortAnswerBlockProps {
  content: ShortAnswerBlockContent
  onAnswer?: (answer: string) => void
  answer?: string
  theme?: Theme | null
  previewMode?: "desktop" | "mobile"
}

export function ShortAnswerBlock({ content, onAnswer, answer: initialAnswer, theme = null }: ShortAnswerBlockProps) {
  const [answer, setAnswer] = useState("")
  
  // Use provided theme or fallback to default
  const activeTheme = theme || defaultTheme

  // Initialize with existing answer if provided
  useEffect(() => {
    if (initialAnswer !== undefined) {
      setAnswer(initialAnswer)
    }
  }, [initialAnswer])

  const handleAnswerChange = (value: string) => {
    setAnswer(value)
    onAnswer?.(value)
  }

  return (
    <div>
      <h3 
        className="text-2xl font-semibold mb-3 text-center"
        style={{ 
          color: activeTheme.colors.text,
          fontFamily: activeTheme.fonts.heading
        }}
      >
        <RichTextRenderer content={content.question} />
      </h3>

      <div className="max-w-2xl mx-auto">
        <input
          type="text"
          value={answer}
          onChange={(e) => handleAnswerChange(e.target.value)}
          placeholder={content.placeholder || "Type your answer here..."}
          className="w-full px-6 py-4 text-lg border-2 border-gray-200 rounded-xl shadow-sm focus:outline-none focus-visible:outline-none transition-all"
          style={{
            boxShadow: 'none',
          } as React.CSSProperties}
          onFocus={(e) => {
            e.target.style.borderColor = activeTheme.colors.primary
            e.target.style.boxShadow = `0 0 0 2px ${activeTheme.colors.primary}40`
          }}
          onBlur={(e) => {
            e.target.style.borderColor = '#e5e7eb'
            e.target.style.boxShadow = 'none'
          }}
        />
      </div>
    </div>
  )
}
